import { Box, BoxProps, keyframes, VStack } from '@chakra-ui/react';

// A light highlight band that sweeps across the placeholder — the classic, clearly
// animated skeleton effect. Muted blue-gray, a touch darker than the page so it reads.
const sweep = keyframes`
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
`;

const SHIMMER_BG = 'linear-gradient(90deg, #C3D4E6 25%, #D8E6F2 50%, #C3D4E6 75%)';
// Solid placeholder shapes (title/chip/lines) sit a shade darker than the sweep.
const PLACEHOLDER = '#A7BFD6';

const Shimmer = (props: BoxProps) => (
  <Box backgroundImage={SHIMMER_BG} backgroundSize="200% 100%" animation={`${sweep} 1.6s linear infinite`} {...props} />
);

type Props = {
  size?: BoxProps['width'];
};

// A single loading placeholder shaped like a content thumbnail card (400x400 by default): the
// card shimmers, with a faint type-chip and title/author lines for structure.
const ContentCardSkeleton = ({ size = '400px' }: Props) => (
  <Shimmer
    width={size}
    aspectRatio={1}
    borderRadius="14px"
    overflow="hidden"
    boxShadow="0px 4px 16px rgba(14, 0, 98, 0.05)"
  >
    <VStack align="stretch" height="100%" padding="20px" justify="space-between">
      <Box width="72px" height="20px" borderRadius="full" backgroundColor={PLACEHOLDER} />
      <VStack align="stretch" gap="10px">
        <Box width="70%" height="22px" borderRadius="6px" backgroundColor={PLACEHOLDER} />
        <Box width="92%" height="12px" borderRadius="6px" backgroundColor={PLACEHOLDER} />
        <Box width="60%" height="12px" borderRadius="6px" backgroundColor={PLACEHOLDER} />
      </VStack>
    </VStack>
  </Shimmer>
);

export default ContentCardSkeleton;
